module.exports = __webpack_public_path__ + "img/Wp_2066.4a91f022.png";